import React, { lazy, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useUser } from "./contexts/UserContext";
import "./App.css";
import Alerts from "./modules/common/Alerts";
import "./styles/Tables.css";
import { BCRContentContainer, BCRSuspense } from "best-common-react-3";

const AuthenticatedApp = lazy(() => import("./modules/common/AuthenticatedApp"));
const UnauthenticatedApp = lazy(() => import("./modules/common/UnauthenticatedApp"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App: React.FC = () => {
  const { loggedIn } = useUser();

  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<BCRSuspense />}>
        <BCRContentContainer>
          <Alerts />
          <BrowserRouter>{loggedIn ? <AuthenticatedApp /> : <UnauthenticatedApp />}</BrowserRouter>
        </BCRContentContainer>
      </Suspense>
    </QueryClientProvider>
  );
};

export default App;
